import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';

var NoData = function NoData() {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      globalLocale = _useContext.locale;

  var cityPickerLang = globalLocale.getCompLangMsg({
    componentName: 'CityPicker'
  });
  var cityPickerPrefixCls = getPrefixCls(prefixCls, 'city-picker');
  var cls = classNames("".concat(cityPickerPrefixCls, "-no-data"));
  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, cityPickerLang.noData);
};

export default NoData;